import { ONBOARDING_IMAGES } from 'core/assets';
import MobileNumberInput from './MobileNumberInput/MobileNumberInput';
import { useEffect, useState } from 'react';
import { trackEvent } from 'src/utils/adapter/gobbler';
import { CompleteTxnDetailIcon } from '@groww-tech-pvt/icon-store/custom';
import { GobblerNOFWebOnbPageView, GobblerNOFWebOnbSuccessState } from '@groww-tech-pvt/gobbler-proto-ts/dist';

import OnbImage from 'src/components/Image';
import ActionFooter from 'src/components/ActionFooter';
import ScreenConfig from 'src/components/ScreenConfig';
import { MOBILE_LAYOUT_MAX_WIDTH_PX, APP_DOWNLOAD_URL } from 'src/utils/constants';


const SCREEN_TYPES = {
  MOBILE_NUMBER_INPUT: 'MOBILE_NUMBER_INPUT',
  SUCCESS_SCREEN: 'SUCCESS_SCREEN',
};


const AppQr = () => {
  const [screen, setScreen] = useState(SCREEN_TYPES.MOBILE_NUMBER_INPUT);
  const [mobileNumber, setMobileNumber] = useState('');
  const [isMobileViewport, setIsMobileViewport] = useState(false);

  const title = 'Groww lets you invest as an Individual, HUF or NRI';

  useEffect(() => {
    trackEvent('GobblerNOFWebOnbPageView', GobblerNOFWebOnbPageView, {
      dataType: 'AppQrScreen',
    });
  }, []);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_LAYOUT_MAX_WIDTH_PX}px)`);
    const sync = () => setIsMobileViewport(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  const onSuccess = () => {
    trackEvent('GobblerNOFWebOnbSuccessState', GobblerNOFWebOnbSuccessState, { state: 'sms_sent_successfully' });
    setScreen(SCREEN_TYPES.SUCCESS_SCREEN);
  };

  const getMobileLinkUi = () => {
    switch (screen) {
      case SCREEN_TYPES.MOBILE_NUMBER_INPUT:
        return (
          <MobileNumberInput
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            onSuccess={onSuccess}
          />
        );

      case SCREEN_TYPES.SUCCESS_SCREEN:
        return (
          <div className='adp901SuccessScreen absolute-center'>
            <CompleteTxnDetailIcon
              size={80}
              className='adp901SuccessIcon'
              data-test-id='onboarding-app-download-sms-success-icon'
            />
            <div
              className='adp901SuccessText'
              data-test-id='onboarding-app-download-sms-success-text'
            >
              SMS sent to +91 {mobileNumber}.<br /> Check your inbox.
            </div>
          </div>
        );
    }
  };

  if (isMobileViewport) {
    return (
      <div className="h-full flex flex-col min-h-0">
        <div className="headingBase mb-4">{title}</div>
        <div className="flex-1 flex flex-col items-center justify-center min-h-0 mb-4">
          <OnbImage
            src={ONBOARDING_IMAGES.DOWNLOAD_APP_MSITE}
            width="200px"
            height="auto"
            alt=""
            className="max-w-md object-contain"
          />
        </div>
        <ActionFooter
          primaryButton={{
            text: 'Download Groww app',
            onClick: () => window.location.assign(APP_DOWNLOAD_URL),
          }}
        />
      </div>
    );
  }

  const getLeftSideUi = () => {
    return (
      <div className="h-full flex flex-col w-full">
        <ScreenConfig heading={title} />
        <div className='flex h-full absolute-center gap-6'>
          <div className='flex flex-column valign-wrapper'>
            <div className='mb-2 center-align bodyBase'>Scan here to continue on the Groww app</div>
            <OnbImage
              src={ONBOARDING_IMAGES.APP_QR_CODE}
              width={'240px'}
              height={'auto'}
            />
          </div>
          <div className='contentSecondary'>or</div>
          <div className='flex flex-column gap-2.5'>
            {getMobileLinkUi()}
          </div>

        </div>
      </div>
    );
  }

  return (
    <div className='flex h-full gap-6 w-full'>
      {getLeftSideUi()}
    </div>
  )
};

export default AppQr;
